import { render, staticRenderFns } from "./AgentMonitor.vue?vue&type=template&id=2b3a535d&scoped=true"
import script from "./AgentMonitor.vue?vue&type=script&lang=js"
export * from "./AgentMonitor.vue?vue&type=script&lang=js"
import style0 from "./AgentMonitor.vue?vue&type=style&index=0&id=2b3a535d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a535d",
  null
  
)

export default component.exports